import React from 'react'
import PrimaryTheme from '../../Themes/Primary'
import Input from '../../components/Input'
import Header from '../../components/Header'
import { useDispatch, useSelector } from 'react-redux'
import { getToken, resetPassword } from '../../redux/actions/userActions'
import AlertModal from '../../components/Modal'
import Alert from '../../components/Alert'
import { useSnackbar } from 'notistack'
import { useHistory } from 'react-router-dom'
import { Reducers } from '../../Interfaces/Interfaces'

export default function ResetPin() {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const history = useHistory();

  const alert = useSelector((state: Reducers) => state.alert);

  // const [page, setPage] = React.useState(1)
  const [passwordValid, setPasswordValid]: any = React.useState(null);
  const [confirmPasswordValid, setConfirmPasswordValid]: any = React.useState(null);
  const [confirmPassword, setConfirmPassword] = React.useState('');
  const [password, setPassword] = React.useState('');
  const [submitted, setSubmitted] = React.useState(false);
  const [emailValid, setEmailValid]: any = React.useState(null);
  const [email, setEmail]: any = React.useState('');

  const handleClick = () => {
    dispatch({ type: "ALERT_MODAL", payload: false });
    window.location.href = '/';
  }

  const validateEmail = (text: string) => {
    // email pattern
    let reg = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
    if (!reg.test(text)) {
      setEmailValid(false);
      setEmail(text.toLowerCase());
    } else {
      setEmailValid(true);
      setEmail(text);
    }
  };


  React.useEffect(() => {
    if (password !== '') {
      let reg = /(?=.*\d)(?=.*[a-z]*[A-Z]).{6,}/;
      // min 6 chars
      //  number required
      //   uppercase letter
      if (!reg.test(password)) {
        setPasswordValid(false);
      } else {
        setPasswordValid(true);
      }
    }
  }, [password])

  React.useEffect(() => {
    if (confirmPassword !== '') {
      if (password === confirmPassword) {
        setConfirmPasswordValid(true);
      } else {
        setConfirmPasswordValid(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [confirmPassword])

  const handleSubmit = () => {
    // open spinner
    // dispatch({
    //   type: 'LOADING',
    //   payload: true
    // });

    setSubmitted(true);

    let user = {
      username: email,
      confirmPassword,
      password: password,
      code: window.location.search.replace('?code=', '')
    };

    dispatch(resetPassword(user));
  };

  React.useEffect(() => {
    let token = {
      client_id: 'client',
      client_secret: 'secret',
      grant_type: 'client_credentials'
    };

    dispatch(getToken(token))

  }, [dispatch]);

  React.useEffect(() => {
    if (Object.entries(alert).length !== 0) {
      if (!alert.successful) {
        // display error message
        enqueueSnackbar(alert.message, { variant: "error" });

        // if (alert.message === 'Network request failed') {
        //   history.push('/networkError');
        // }

        dispatch({
          type: 'ALERT',
          payload: {}
        });
        dispatch({
          type: 'LOADING',
          payload: false
        });

        setSubmitted(false);

      } else {
        enqueueSnackbar(alert.message, { variant: "success" });

        dispatch({
          type: 'ALERT',
          payload: {}
        });

        dispatch({ type: "ALERT_MODAL", payload: true })

        // setTimeout(() => {
        //   dispatch({
        //     type: 'LOADING',
        //     payload: false
        //   });

        //   // window.location.pathname = '/';
        // }, 2000);
      }
    }
  }, [dispatch, enqueueSnackbar, alert, history]);

  return (
    <div style={{ backgroundColor: PrimaryTheme.surface }}>

      <div className="row m-0" style={{ backgroundColor: PrimaryTheme.surface }}>

        <Header classNames="d-md-none" />

        {/* form */}
        <div className="col-md-6 hero-left" style={{
          background: PrimaryTheme.primary,
          minHeight: '100vh',
          height: 'auto',
        }}>

          <a className="navbar-brand" href="/" style={{
            fontFamily: PrimaryTheme.fonts?.RubikLight,
            marginTop: 40,
          }}>
            <img src="/logo.png" width="150" className="d-inline-block align-top" alt="" loading="lazy" />
          </a>

          <h1 className="" style={{
            marginTop: 128,
            fontFamily: PrimaryTheme.fonts?.RubikMedium,
            color: PrimaryTheme.white,
            fontSize: PrimaryTheme.fontSizes?.heading
          }}>Password Reset</h1>
          <p style={{
            fontFamily: PrimaryTheme.fonts?.RubikRegular,
            fontSize: PrimaryTheme.fontSizes?.body,
            color: PrimaryTheme.white
          }}>Set a new password.</p>

          <div className="col-md-9 p-0 mr-auto" style={{
            marginTop: 30
          }}>
            <form noValidate>

              <Input
                type='email'
                placeholder='Email Address'
                autoComplete="email"
                showIcon
                required
                valid={emailValid}
                value={email}
                inputMode="email"
                onChange={e => validateEmail(e.target.value)}
                isInput style={{
                  fontFamily: PrimaryTheme.fonts?.RubikLight,
                  color: PrimaryTheme.dark,
                }} />

              <Input
                type='password'
                valid={passwordValid}
                value={password}
                placeholder='New Password'
                required
                showIcon
                inputMode="text"
                onChange={e => setPassword(e.target.value)}
                isInput style={{
                  fontFamily: PrimaryTheme.fonts?.RubikLight,
                  color: PrimaryTheme.dark,
                }} />

              <Input
                type="password"
                valid={confirmPasswordValid}
                value={confirmPassword}
                placeholder='Confirm Password'
                required
                showIcon
                inputMode="text"
                onChange={e => setConfirmPassword(e.target.value)}
                isInput style={{
                  fontFamily: PrimaryTheme.fonts?.RubikLight,
                  color: PrimaryTheme.dark,
                }} />

              <Input
                onClick={handleSubmit}
                type='button'
                isInput
                value={submitted ? 'Resetting...' : 'Reset Password'}
                disabled={!passwordValid || !confirmPasswordValid || submitted}
                style={{
                  background: PrimaryTheme.warn,
                  fontFamily: PrimaryTheme.fonts?.RubikMedium,
                }} className='text-bold border-0' />

            </form>
          </div>
        </div>

        {/* hero image */}
        <div className="col-md-6 d-none d-md-block hero-right" style={{
          background: PrimaryTheme.surface,
          minHeight: '100vh',
          height: 'auto',
          paddingTop: 18,
          backgroundPosition: "center center",
          backgroundImage: "url('/security.png')",
          backgroundRepeat: "no-repeat",
          backgroundSize: "70% auto"
        }}>
          <div className="row justify-content-end">
            <ul className="navbar nav">
              {/* <li className='nav-item'>
                <button onClick={() => handleOpen(2)} className="btn nav-link" style={{
                  fontFamily: PrimaryTheme.fonts?.RubikMedium,
                  fontSize: PrimaryTheme.fontSizes?.anchor,
                  color: PrimaryTheme.dark
                }} >Become A Merchant</button>
              </li> */}
              <li className='nav-item'>
                <a className="nav-link" style={{
                  fontFamily: PrimaryTheme.fonts?.RubikMedium,
                  fontSize: PrimaryTheme.fontSizes?.anchor,
                  color: PrimaryTheme.dark
                }} href="https://bankly.ng/about-us" target="_blank" rel='noopener noreferrer' >About Us</a>
              </li>
              <li className='nav-item'>
                <a className="nav-link" style={{
                  fontFamily: PrimaryTheme.fonts?.RubikMedium,
                  fontSize: PrimaryTheme.fontSizes?.anchor,
                  color: PrimaryTheme.dark
                }} href="/" target="_blank" rel='noopener noreferrer'>Contact Us</a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <AlertModal>
        <Alert
          title="Password Reset Successful"
          body="Your password has been reset successfully. Login to continue."
          value={"Login"}
          onClick={handleClick}
        />
      </AlertModal>

    </div>
  )
}
